import keyBy from 'lodash/keyBy'

const setAll = (state, staffs) => {
  Object.assign(state, { all: { ...state.all, ...keyBy(staffs, 'id') } })
}

export default {
  setAll
}
